// Vendor
import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
// Globals
import { ACCESS_TOKEN_KEY, IMPERSONATING_KEY, REFRESH_TOKEN_KEY, ROLE } from './globals/state';
// Stores
import { useContextStore } from '../context';
export const useAuthentication = defineStore('authentication', () => {
    // Composable
    const { $api, $endpoints } = useContextStore();
    // Refs
    const accessToken = ref(null);
    const refreshToken = ref(null);
    const role = ref(ROLE.ANONYMOUS);
    const impersonatedUser = ref(undefined);
    // Computed
    const isAuthenticated = computed(() => role.value > ROLE.ANONYMOUS);
    const isImpersonating = computed(() => !!impersonatedUser.value);
    // Methods
    async function authenticate(options) {
        const { password, userField = 'email', username } = options;
        const response = await $api
            .post($endpoints.LOGIN, {
            [userField]: username,
            password,
        })
            .catch((error) => Promise.reject(error));
        const { data } = response;
        if (data) {
            startSession(data, ROLE.USER);
            return data;
        }
        return null;
    }
    async function refreshAuthentication() {
        if (!refreshToken.value) {
            return Promise.reject({
                message: 'No refresh token found',
                status: 401,
            });
        }
        const response = await $api
            .post($endpoints.TOKEN_REFRESH, {
            refresh_token: refreshToken.value,
        })
            .catch((error) => Promise.reject(error));
        const { data } = response;
        if (data) {
            startSession(data, ROLE.USER);
            return data;
        }
        return null;
    }
    async function removeSession() {
        role.value = ROLE.ANONYMOUS;
        accessToken.value = null;
        refreshToken.value = null;
        stopImpersonating();
        return role.value;
    }
    async function startSession(tokenData, userRole) {
        role.value = userRole;
        accessToken.value = tokenData.token;
        refreshToken.value = tokenData.refresh_token;
        return role.value;
    }
    function startImpersonating(userName) {
        impersonatedUser.value = userName;
    }
    function stopImpersonating() {
        impersonatedUser.value = undefined;
    }
    return {
        [ACCESS_TOKEN_KEY]: accessToken,
        [REFRESH_TOKEN_KEY]: refreshToken,
        [IMPERSONATING_KEY]: impersonatedUser,
        authenticate,
        isAuthenticated,
        isImpersonating,
        refreshAuthentication,
        removeSession,
        role,
        startSession,
        startImpersonating,
        stopImpersonating,
    };
}, {
    persist: {
        key: 'a',
        paths: [ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY, IMPERSONATING_KEY, 'role'],
    },
});
export * from './globals/request';
export * from './globals/state';
//# sourceMappingURL=module.js.map